import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthComponent } from './core/auth/auth.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HomeComponent } from './core/home/home.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

//import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MaterialExampleModule } from '../material.module';
import { RecargaDirective } from './core/directive/recarga.directive';
import { SitesComponent } from './core/sites/sites.component';
import { InicioComponent } from './core/inicio/inicio.component';
import { HeadersInterceptor } from './helpers/headers.interceptor';
import { AuthInterceptorInterceptor } from './helpers/auth-interceptor.interceptor';
import { ReportOrderRoutingModule } from './core/instalaciones/report-order/report-order-routing.module';
import { NumericInputDirective } from './directivas/numeric-input.directive';
import { environment } from 'src/environments/environment';
// import {initializeApp} from 'firebase/app';

// initializeApp(environment.firebase)
@NgModule({
  declarations: [AppComponent, RecargaDirective, NumericInputDirective],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot([]),
    MaterialExampleModule,
    ReportOrderRoutingModule,

  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeadersInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorInterceptor,
      multi: true,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
